// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Y1qgp","label":"CategoryService_label__SjN4b","location":"CategoryService_location__2mGJw"};